import apiClient from './api-client'

function get(cycleId) {
  return apiClient.get(`/reports/cycles/${cycleId}/batch`)
}

function create(cycleId) {
  return apiClient.post(`/reports/cycles/${cycleId}/batch`)
}

function zipFile(cycleId) {
  return apiClient.get(`reports/cycles/${cycleId}/file`)
}

export default {
  get,
  create,
  zipFile,
}
